
if (!customElements.get('lsg-rtx')) customElements.define('lsg-rtx', class LSGRtx extends HTMLElement {
    constructor() {
        super();
        this.prod = JSON.parse(this.querySelector('[data-product-data]').innerHTML || '{}');
        this.dropdowns = this.querySelectorAll('[name="rtx_option_plans_dropdown"]');
        this.spg_radios = this.querySelectorAll(`input[name="selling_plan_select__${this.prod.id}"]`);
        this.disclaimerTriggers = this.querySelectorAll('[rtx-value-prop-disclaimer-trigger]');
        this.disclaimerOverlays = this.querySelectorAll('[rtx-value-prop-disclaimer-overlay]');
        this.prodForm = this.closest('form');
        this.selling_plan_input = this.prodForm.querySelector('input[name="selling_plan"]');
        this.otpPrice = this.getAttribute('data-otp-price');
        this.subPrice = this.getAttribute('data-sub-price');
        this.init();
    }

    setSellingPlan() {
        const selectedOption = [...this.spg_radios].find(radio => radio.checked);
        const totalPriceEls = this.prodForm.querySelectorAll('.custom_price_display .total_price');
        const displayPriceEls = this.prodForm.querySelectorAll('.add_to_cart_button .display_price');
        if (selectedOption.value === "onetime") {
            this.selling_plan_input.value = "";
            [...totalPriceEls, ...displayPriceEls].forEach((priceEl) => {
                priceEl.innerHTML = this.otpPrice;
            });
        } else {
            this.selling_plan_input.value = this.prodForm.querySelector(`[name="selling_plan_select__${this.prod.id}"]:checked + label [name="rtx_option_plans_dropdown"]`).value;
            [...totalPriceEls, ...displayPriceEls].forEach((priceEl) => {
                priceEl.innerHTML = this.subPrice;
            });
        }
    }

    init() {
        this.dropdowns.forEach(dropdown => {
            dropdown.addEventListener("change", () => {
                this.setSellingPlan();
            });
        });
        this.spg_radios.forEach(spg_radio => {
            spg_radio.addEventListener('change', () => {
                this.setSellingPlan();
            });
        });
        this.setSellingPlan();
        this.disclaimerTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const disclaimer = trigger.closest('[rtx-value-prop-disclaimer]');
                if (disclaimer) {
                    disclaimer.classList.add('active');
                }
            });
        });
        this.disclaimerOverlays.forEach(overlay => {
            overlay.addEventListener('click', () => {
                const disclaimer = overlay.closest('[rtx-value-prop-disclaimer]');
                if (disclaimer) {
                    disclaimer.classList.remove('active');
                }
            });
        });
    }
});
